module.exports = __webpack_public_path__ + "img/mobdifflevel.e2c879e6.svg";